var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesforceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M7.491 1.374a3.154 3.154 0 012.283-.98c1.188 0 2.225.663 2.777 1.646a3.838 3.838 0 011.57-.333c2.143 0 3.88 1.753 3.88 3.915s-1.737 3.915-3.88 3.915c-.257 0-.513-.026-.765-.077a2.836 2.836 0 01-3.717 1.168 3.237 3.237 0 01-6.017-.147 2.97 2.97 0 01-.617.065C1.345 10.546 0 9.186 0 7.51a3.04 3.04 0 011.502-2.63A3.494 3.494 0 014.711 0c1.134 0 2.141.539 2.78 1.374"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceIcon);
export default ForwardRef;